import styled from 'styled-components';
import mediaQueries from '../../styles/mediaQueries';
import { colors } from '../../styles/constants';
import { Centered } from '../Layout';
import Link from '../Link';
import Input from '../Input';

export const CenteredWithGutters = styled(Centered)`
  max-width: 720px;
  margin: 16px auto;
  text-align: left;
`;

export const StyledLabel = styled.p`
  font-size: 16px;
  color: ${colors.black};
`;

export const SubLabel = styled.p`
  line-height: 24px;
  margin-bottom: 6px;
  font-size: 16px;
  color: ${colors.black};
`;

export const BtnContainer = styled.div`
  margin: 0 auto;
`;

export const BottomLink = styled(Link)`
  color: ${colors.darkPurple};
  text-decoration: underline;
`;

export const HalfInput = styled(Input)`
  width: 50%;
  ${mediaQueries.mobile`
    width: 100%;
  `};
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${mediaQueries.mobile`
    flex-direction: column;
  `};
`;

export const PrivacyLabel = styled.p`
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  margin-bottom: 16px;
  color: ${colors.black};

  ${mediaQueries.mobile`
    width: 300px;
  `};
`;

export const SubmitLabel = styled.p`
  font-size: 16px;
  line-height: 18px;
  text-align: left;
  margin-bottom: 16px;
  color: ${colors.black};

  ${mediaQueries.mobile`
    font-size: 12px;
    width: 320px;
    text-align: center;
  `};
`;

export const SubmitSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: left;
`;

export const RadioButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  margin-top: 5px;
`;

export const DiagnosisSection = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledRadio = styled.div`
  input[type='radio'] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 16px;
    height: 16px;
    border: 2px solid #999;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    position: relative;
    margin-right: 6px;
    display: inline-block;
    vertical-align: middle;

    &:checked::before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #333;
    }
  }
`;

export const FileUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
